import { html } from "htm/preact";
import { useState } from "preact/hooks";
import { UnderlineLink } from "../new/underline-link";
import { GridIcon, GlobeIcon } from "../new/icons";

export const OverlaySlideDown = ({ isActive = false, setActive, children }) => {
  const translateY = isActive ? "0%" : "-100%";
  const opacity = isActive ? "100%" : "0%";
  const closeSlider = () => setActive(false);
  return html`
    <section
      className="bg-primary-50 absolute top-0 left-0 right-0 h-full w-full transition-all duration-500 ease-in-out overflow-y-auto z-40"
      style="transform:translateY(${translateY}); opacity: opacity"
    >
      <div className="max-w-6xl mx-auto pt-20 lg:pt-32 px-10 lg:px-20 flex flex-col">
        <button className="hidden lg:block button h-20 w-20 button-light self-end" onClick="${closeSlider}">
          <svg viewBox="0 0 24 24" title="Delete" size="42" className="l5">
            <title>Delete</title>
            <path
              d="M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
            ></path>
          </svg>
        </button>
        <div className="w-full">${children}</div>
      </div>
    </section>
  `;
};

export const LanguageSlider = () => {
  return html`
    <div className="flex flex-col">
      <h4 className="text-4xl font-medium px-4">Select your preferred language</h4>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-4 gap-10">
        <button className="button button-lg button-light button-flat text-left active">English</button>
        <button className="button button-lg button-light button-flat text-left">简体中文</button>
        <button className="button button-lg button-light button-flat text-left">Español (Internacional)</button>
      </div>
    </div>
  `;
};

export const MobileMenu = ({ isSlideActive, setSlideActive, setActiveSlideDown }) => {
  return html`
    <div className="flex flex-col">
      <a href="#" className="py-2 text-4xl font-medium">
        Company
      </a>
      <a href="#" className="py-2 text-4xl font-medium">
        Safety
      </a>
      <a href="#" className="py-2 text-4xl font-medium">
        Help
      </a>
      <a href="#" className="py-2 text-4xl font-medium">
        COVID-19 resources
      </a>
      <button type="button" className="button button-lg button-flat flex justify-center mt-10">
        <${GridIcon} />
        <span className="ml-3 text-lg leading-none">Products</span>
      </button>
      <button className="button button-lg button-light self-start flex mt-5" onClick="${() => setActiveSlideDown(0)}">
        <${GlobeIcon} />
        <span className="ml-2">EN</span>
      </button>
    </div>
  `;
};

export const LoginOverlaySlide = () => {
  return html`
    <div
      className="col-span-3 mt-16 lg:mt-32 grid grid-cols-1 lg:grid-cols-2 gap-20 text-4xl font-medium px-5 lg:px-16"
    >
      <${UnderlineLink} href="#">
        <div className="flex justify-between pb-4">
          <span>Driver Login</span>
          <span className="whitespace-no-wrap">-></span>
        </div>
      <//>
      <${UnderlineLink} href="#">
        <div className="flex justify-between pb-4">
          <span>Rider Login</span>
          <span className="whitespace-no-wrap">-></span>
        </div>
      <//>
    </div>
  `;
};
